import { FONT_BRIGHTNESS_MAPPING } from './constants';
import { fontSizes } from './fontSizes';
import { fontWeights } from './fontWeights';
export const label = ({ themeVariables, }) => {
    const { fontBrightness } = themeVariables;
    const asphalt = FONT_BRIGHTNESS_MAPPING.asphalt[fontBrightness];
    return {
        color: asphalt,
        cursor: 'pointer !important',
        fontSize: fontSizes[2],
        fontWeight: fontWeights[1],
        marginToInput: 2,
        marginToLegendRadioInputs: 4,
    };
};
//# sourceMappingURL=label.js.map